module.exports = __webpack_public_path__ + "resources/img/logo_NHN.d3a93db30abe29cbdd93744b8b0a974e.png";